import {useEffect} from 'react';

// import { Link } from 'react-router-dom';
import CustomizePackagingMaterials from './CustomizePackagingMaterials';
import EndToEndRelocatedSolution from './EndToEndRelocatedSolution';
import ProfessionalTeam from './ProfessionalTeam';
import Transportation from './Transportation';



const PacknGOs = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
  
  
    return(
        <div>
            <div id='international' className="packngo-image">
                <img src='/packngo/packngo.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[50px]">
                <p>
                    TCS offers a hassle-free and relaxed experience of moving from one premises to another. 
                    PackNGo team takes care of the smallest details of the move. With every PackNGo customer 
                    empowered to choose the services exactly attuned to meet their packing and moving needs, 
                    each individual and business gets a service package specifically tailor-made to their needs.
                </p>
                <p>
                    Professional guidance is provided to the customers by trained TCS teams experienced in packing, 
                    shifting and transportation, before finalising the contract and throughout the process. Single 
                    point-of-contact, flexible and transparent quotations and proposals, customised documentation, 
                    organised and planned packing and movement, trained and professional teams and temporary storage 
                    facilities available at TCS warehouses in Karachi, Lahore and Islamabad, leave nothing for a chance.
                </p>
                
                
                 
            </div>
            
            
           
            <CustomizePackagingMaterials/>
            <EndToEndRelocatedSolution/>
            <ProfessionalTeam/>
            <Transportation/>
          
            



            

        </div>
    )
};
export default PacknGOs;